import React, { type FC } from 'react';
import { Search } from '../../components/common/search';
import { HeaderSection } from './components/header-section';
import { MainPostSection } from './components/main-post-section';
import { SliderSection } from './components/slider-section';
import type { LearnPageProps } from './types';

const LearnPage: FC<LearnPageProps> = ({
    data: {
        allStrapiArticle: { edges: data },
        featured: { edges },
    },
    popularPosts,
}) => (
    <section className="learn">
        <div className="bg-titleSection relative mt-16">
            <div className=" max-w-6xl mx-auto px-5">
                <HeaderSection />
                <Search />
                <MainPostSection edges={edges} />
            </div>
            <SliderSection data={data} popularPosts={popularPosts} />
        </div>
    </section>
);

export default LearnPage;
